import React from 'react';

import { parseHtml } from '../helpers';

type Props = {
  title: string;
  strapline?: string;
};

export const LinkHeader: React.FC<Props> = ({ title, strapline }) => {
  return (
    <>
      <h2 data-testid='mp-product-link-title'>{title}</h2>
      {strapline ? (
        <p className='strapline' data-testid='mp-product-link-description'>
          {parseHtml(strapline)}
        </p>
      ) : null}
    </>
  );
};
